import {
  cancelContent,
  cancelWithRemoveContent,
  clickContent,
  clickContentEditor,
  clickMenuClose,
  clickMenuMoveDownContent,
  clickMenuMoveUpContent,
  clickMenuRemoveContent,
  clickMenuSurvey,
  clickRestoreRemoveContent,
  insertContent,
  saveContent,
  saveWithRemoveContent,
  saveWithShallowRemoveContent,
} from "../../../actions/pages/editor/editorActionCreator"
import { ReduxAction } from "../../../reducers"
import { IEditorContent } from "../types"

export class ContentActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public clickContentEditor(uuid: string) {
    this.dispatch(clickContentEditor(uuid))
  }

  public clickContent(uuid: string) {
    this.dispatch(clickContent(uuid))
  }

  public insertContent(content: IEditorContent, uuidPrevInsert: string) {
    this.dispatch(insertContent(content, uuidPrevInsert))
  }

  public clickMenuMoveUpContent(uuid: string) {
    this.dispatch(clickMenuMoveUpContent(uuid))
  }

  public clickMenuMoveDownContent(uuid: string) {
    this.dispatch(clickMenuMoveDownContent(uuid))
  }

  public clickMenuSurvey(uuid: string) {
    this.dispatch(clickMenuSurvey(uuid))
  }

  public clickMenuClose() {
    this.dispatch(clickMenuClose())
  }

  public clickRemoveContent(uuid: string) {
    this.dispatch(clickMenuRemoveContent(uuid))
  }

  public clickRestoreRemoveContent(uuid: string) {
    this.dispatch(clickRestoreRemoveContent(uuid))
  }

  public saveContent(content: IEditorContent) {
    this.dispatch(saveContent(content))
  }

  public saveWithShallowRemoveContent(uuid: string) {
    this.dispatch(saveWithShallowRemoveContent(uuid))
  }

  public saveWithRemoveContent(uuid: string) {
    this.dispatch(saveWithRemoveContent(uuid))
  }

  public cancelContent(uuid: string) {
    this.dispatch(cancelContent(uuid))
  }

  public cancelWithRemoveContent(uuid: string) {
    this.dispatch(cancelWithRemoveContent(uuid))
  }
}
